// @owners { team: patients-team }
import { COLORS } from '@alto/design-library-tokens';
import { ActionSheetContext, Description, Pressable } from '@alto/design-system';
import React, { useCallback, useContext, useEffect } from 'react';
import { useAnalytics } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { FeeDetailsActionSheet } from '../select-date-card/FeeDetailsActionSheet';

export const FeeDetails = () => {
  const { setActiveActionSheet } = useContext(ActionSheetContext);
  const { trackEvent } = useAnalytics();

  useEffect(() => {
    trackEvent({ event: EVENTS.SCHEDULING_CARD_FEE_DETAILS_LINK_VIEWED });
  }, [trackEvent]);

  const handleFeeDetailsPress = useCallback(() => {
    setActiveActionSheet(<FeeDetailsActionSheet />);
  }, [setActiveActionSheet]);

  return (
    <Pressable onPress={handleFeeDetailsPress}>
      <Description
        color={COLORS.TEXT_COLORS.SECONDARY_DARK}
        fontFamily="semibold"
      >
        Fee details
      </Description>
    </Pressable>
  );
};
